import { useCallback } from 'react';
import {
  Button,
  ButtonSizeMD,
  ButtonVariants,
} from '@picsart/design-system/components/Button';
import {
  InlineButton,
  InlineButtonAlignments,
  ControlSizesSM,
} from '@picsart/design-system/components/InlineButton';
import { IconLogout } from '@picsart/design-system/foundation/icons/IconLogout';

import { logout, deleteAccount } from '@/utils/user/authActions';
import useStyles from './styles';

interface SettingsActionsProps {
  isAuthorized: boolean;
}

const SettingsActions = ({ isAuthorized }: SettingsActionsProps) => {
  const classes = useStyles();

  const handleLogout = useCallback(() => logout(), []);
  const handleDeleteAccount = useCallback(() => deleteAccount(), []);

  if (!isAuthorized) return null;

  return (
    <div className={classes.actions}>
      <Button
        dataTestId="genai-settings-log-out"
        variant={ButtonVariants.Outline}
        size={ButtonSizeMD}
        startIcon={IconLogout}
        isFullWidth
        onClick={handleLogout}
      >
        Log Out
      </Button>
      <InlineButton
        className={classes.deleteAccountButton}
        dataTestId="genai-settings-delete-account"
        size={ControlSizesSM}
        alignment={InlineButtonAlignments.Center}
        isWithoutBorder
        isWithoutBackground
        onClick={handleDeleteAccount}
      >
        Delete account
      </InlineButton>
    </div>
  );
};

export default SettingsActions;
